import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { IconAlertTriangleFilled, IconX } from '@tabler/icons-react';

const UnsavedChangesModal = ({ show, onStay, onDiscard }) => {
  return (
    <Modal
      show={show}
      onHide={onStay}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="flex items-center justify-between p-6 border-b border-gray-200">
        <Modal.Title className="text-lg font-semibold text-gray-900">
          Unsaved Changes Detected
        </Modal.Title>
        <button
          type="button"
          className="p-2 hover:bg-gray-100 rounded-md transition-colors"
          onClick={onStay}
          aria-label="Close"
        >
          <IconX size={20} className="text-gray-500" />
        </button>
      </Modal.Header>
      <Modal.Body className="p-6">
        <div className="text-center">
          <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-amber-100">
            <IconAlertTriangleFilled size={28} className="text-amber-600" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Unsaved Changes Detected
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed max-w-md mx-auto">
            You have unsaved changes. If you leave now, your updates will be
            lost. Do you want to continue?
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex gap-3 justify-end p-6 border-t border-gray-200 bg-white">
        <button
          type="button"
          className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          onClick={onDiscard}
        >
          Discard
        </button>
        <button
          type="button"
          className="px-5 py-2.5 text-sm font-medium text-white bg-primary hover:bg-primary/90 rounded-lg transition-colors"
          onClick={onStay}
        >
          Stay on Page
        </button>
      </Modal.Footer>
    </Modal>
  );
};

UnsavedChangesModal.propTypes = {
  show: PropTypes.bool,
  onStay: PropTypes.func,
  onDiscard: PropTypes.func,
};

export default UnsavedChangesModal;
